import { render, staticRenderFns } from "./ShopCarts.vue?vue&type=template&id=8b16dcf8"
import script from "./ShopCarts.vue?vue&type=script&lang=js"
export * from "./ShopCarts.vue?vue&type=script&lang=js"
import style0 from "./ShopCarts.vue?vue&type=style&index=0&id=8b16dcf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports